import { useEffect } from "react";
import { generateUUID } from "Utilities/generateUUID";
import { usePaymentPage } from "./PaymentPageContext";

export function useGenerateAndSetTabID() {
  const { dispatch } = usePaymentPage();

  useEffect(() => {
    const uuid = generateUUID();
    dispatch({
      type: "setTabID",
      payload: uuid,
    });
  }, [dispatch]);
}
